import { render, staticRenderFns } from "./pickup-dsk.vue?vue&type=template&id=71a93822&scoped=true"
import script from "./pickup-dsk.vue?vue&type=script&lang=ts"
export * from "./pickup-dsk.vue?vue&type=script&lang=ts"
import style0 from "./pickup-dsk.vue?vue&type=style&index=0&id=71a93822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a93822",
  null
  
)

export default component.exports